import React, { useState, useRef , useEffect} from "react";
import { Link, useNavigate,useLocation,  useSearchParams  } from "react-router-dom";
import { Pagination, EffectFade, Autoplay } from "swiper/modules";

import { useTranslation } from "react-i18next";

import mainBg from "../assets/main_bg_nu_new.png";

import { AuthMe } from "../lib/MyHttp";
import { Update } from "../lib/User";


const Main = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [data, setData] = useState();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        let token = searchParams.get("token");
        if (!!token) {
            localStorage.setItem("fb_token", token);
        } else {
            token = localStorage.getItem("fb_token");
        }

        if (!!token && data) {
            data.fb_token = token;
            Update(
                data,
                res => {
                    localStorage.setItem("fb_token", "");
                },
                res => {}
            );
        }
    }, [searchParams, data]);

    useEffect(() => {
        AuthMe(
            res => {
                setData(res);
            },
            res => {
                setData();
            }
        );

        return () => {};
    }, []);


    const clickStart= () => {
        navigate('/about');
    };

    const clickLogin= () => {
        navigate('/login');
    };


    return (
        <main className="main-container">
            <div className="main-bg">
                <img src={mainBg} />
            </div>

            <div className="start-btn-area">
                 {!data && (<button className="Start" onClick={() => clickLogin()}>시작하기</button>)}
                 {data && (<button className="Start" onClick={() => clickStart()}>시작하기</button>)}
            </div>
           
        </main>
    );
};

export default Main;
